import { resolveCombinedBarHeight } from '@/shared/configs/toolbar.config';

import { breakpointStore } from '@/client/stores/breakpoint.store';

/** True at/above the desktop breakpoint (Tailwind `lg`). */
export const useIsDesktop = (): boolean => breakpointStore((s) => s.isDesktop);

/**
 * Combined toolbar height (px) for the active breakpoint. SSR-safe: the store
 * falls back to the base height on the server.
 */
export const useCombinedBarHeight = (): number =>
  breakpointStore((s) => resolveCombinedBarHeight(s.isSm, s.isMd));
